import L from 'leaflet';

let _loaded = false;

export default function loadGeoraster() {
  if (_loaded) return Promise.resolve();
  if (window.parseGeoraster && window.GeoRasterLayer) { _loaded = true; return Promise.resolve(); }
  if (!window.L) window.L = L;
  return new Promise((resolve, reject) => {
    const s1 = document.createElement('script');
    s1.src = '/vendor/georaster.browser.bundle.min.js';
    s1.onload = () => {
      const s2 = document.createElement('script');
      s2.src = '/vendor/georaster-layer-for-leaflet.min.js';
      s2.onload = () => { _loaded = true; resolve(); };
      s2.onerror = reject;
      document.head.appendChild(s2);
    };
    s1.onerror = reject;
    document.head.appendChild(s1);
  });
}

export function carbonColorFn(georaster) {
  const min = georaster.mins?.[0] ?? 0;
  const max = georaster.maxs?.[0] ?? 1;
  const range = max - min || 1;
  return (values) => {
    const v = values[0];
    if (v == null || !isFinite(v) || v === georaster.noDataValue) return null;
    const t = Math.max(0, Math.min(1, (v - min) / range));
    const r = Math.round(255 * (1 - t));
    const g = Math.round(180 + 75 * t);
    const b = Math.round(80 * (1 - t));
    return `rgba(${r},${g},${b},0.78)`;
  };
}
